<template>
  <div class="wrap_travelCard">
    <template v-if="isShowLoading">
      <loading></loading>
    </template>
    <div class="cardTitle"><span>我的旅游卡</span></div>
    <div class="tickets" v-if="travelCard.length>0" >
      <div class="addCard">
        <router-link :to="{name: 'TravelCard'}">购买旅游卡＞＞</router-link>
      </div>
      <dl v-for="(item,index) in travelCard" :key="index" >
        <dt>
          <img :class="item.status=='2'?'gray':''" :src="item.imageAddr" alt="图片加载失败" />
        </dt>
        <dd>
          <h3>{{item.name}}</h3>
          <p>
            <span>截止日期：</span>
            <span>{{item.periodEndDate}}</span>
            <Tooltip placement="right" :style="css_detail" >
              <Button type="text">详情</Button>
              <div slot="content" :style="{marginBottom:'20px'}" >
                <p class="ellipsis" :title="item.scenics" >
                  <span>可使用景区:</span> {{item.scenics}}
                </p>
                <p>
                  <span>使用次数:</span> {{item.timesFlag === -1 ? '不限' : item.effectiveTimes + '次'}}
                </p>
                <p>
                  <span>生效时时间:</span> {{item.periodStartDate}}
                </p>
                <p>
                  <span>截止日期:</span> {{item.periodEndDate}}
                </p>
                <p v-if="item.timesFlag === -1">
                  <span>已使用次数:</span> 不限制
                </p>
                <p v-else>
                  <span>已使用次数:</span> {{item.usedTimes}}次
                </p>
                <p v-if="item.timesFlag === -1">
                  <span>剩余次数:</span> 不限制
                </p>
                <p v-else>
                  <span>剩余次数:</span> {{item.leaveTimes}}次
                </p>
                <!-- <p>
                  <span>银行卡卡号:</span> {{item.bankCardNum}}
                </p> -->
                <p class="ellipsis" :title="item.cardNumber" >
                  <span>旅游卡卡号:</span> {{item.cardNumber}}
                </p>
              </div>
            </Tooltip>
          </p>
        </dd>
      </dl>
    </div>
    <div class="tickets" :style="{textAlign:'center'}" v-else >
      <div class="img"></div>
      <div class="Word">暂无可用旅游卡，快去购买吧~</div>
      <Button type="primary">
        <router-link :to="{name: 'TravelCard'}">去购买</router-link>
      </Button>
    </div>
    <!-- <div class="fenye">
      <Page v-if="pageObj.total > 0" :total="pageObj.total" :current="pageObj.currentPage" prev-text="上一页" next-text="下一页" @on-change="changePage">
      </Page>
    </div> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      css_detail: {
        position: 'relative',
        right: '-60px',
      },
      pageObj: {
        total: 0,
        currentPage: 1
      },
      isShowLoading: false,
      travelCard: []
    };
  },
  async mounted () {
    this.gettravel()
  },
  methods: {
    /**
    * 获取我的旅游卡列表，
    **/
    async gettravel () {
      this.isShowLoading = true;
      const res = await this.$api.get2(`${this.lee}/tourcard/tourcard/v1/getUserAllTourCardDetails?${this.QS.stringify({
        usid: sessionStorage.getItem("userName"),
      })}`);
      let today = new Date().getTime()
      if (res.code === 200) {
        this.isShowLoading = false;
        this.travelCard = res.data
        // this.travelCard = res.data && res.data.length > 0 ?
        //   (res.data.filter(item => new Date(item.periodEndDate).getTime() > today)).sort(function (a, b) { return b['periodEndDate'] > a['periodEndDate'] ? 1 : -1 })
        //   : [];
      } else {
        this.isShowLoading = false;
        this.$Modal.warning({
          title: '温馨提示',
          content: res.data.return_msg || res.data.msg
        });
      }
    }
  },
}
</script>

<style lang="less" scoped>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cardTitle {
  margin-top: 20px;
  span {
    font-size: 16px;
    font-weight: bold;
    color: #191919;
  }
}
.tickets {
  cursor: default;
  border-radius: 2px;
  margin-bottom: 32px;

  .addCard {
    color: #4e81f0;
    margin: 10px 10px 20px 0px;
    text-align: right;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
  }
  .fenye {
    text-align: center;
  }
  dl {
    display: inline-block;
    width: 280px;
    margin: 0 15px 32px;
    border-radius: 2px;
    dt {
      border: 1px solid #ececec;
      background-color: #ececec;
      position: relative;
      overflow: hidden;
      img {
        width: 280px;
        height: 180px;
        float: left;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
      }
    }
    dd {
      border: 1px solid #ececec;
      border-radius: 2px;
      border-top: 0;
      padding: 10px;
      h3 {
        margin-bottom: 10px;
      }
      p {
        color: #ccc;
      }
    }
  }
  .img {
    width: 424px;
    height: 237px;
    background: url("../../../../assets/notravelcardPersonal.png") no-repeat
      center 100%;
    margin: 210px auto 0;
  }
  .Word {
    color: #828284;
    font-size: 16px;
    text-align: center;
    line-height: 50px;
  }
  button a {
    color: #fff;
  }
}

//旅游卡过期
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
</style>
